/**
 * Reexport of server side FooterColumns to avoid loading it on client.
 */
const ServerFooterColumnsWrapper = async () => {
  const { default: ServerFooterColumns } =
    await import('./ServerFooterColumns');

  return <ServerFooterColumns />;
};

export default ServerFooterColumnsWrapper;
